import { useState } from 'react';
import { FaShareAlt, FaTimes, FaEnvelope, FaFacebookF, FaTwitter, FaLink } from 'react-icons/fa';
import './ShareModal.css'; // Add CSS for styling

const ShareModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const currentUrl = window.location.href;
  const shareMessage = `Check out this ranking on #Mytop25: ${currentUrl}`;
  const encodedMessage = encodeURIComponent(shareMessage);
  const encodedUrl = encodeURIComponent(currentUrl);

  const toggleModal = () => setIsOpen(!isOpen);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(currentUrl);
    alert('Link copied to clipboard!');
  };

  return (
    <div className="share-container">
      <FaShareAlt className="share-icon" onClick={toggleModal} />
      {isOpen && (
        <div className="mini-modal">
          <FaTimes className="close-icon" onClick={toggleModal} />
          <h2>Share this page</h2>
          <div className="share-options">
            <a href={`mailto:?subject=Check this out&body=${encodedMessage}`} className="share-option">
              <FaEnvelope /> Email
            </a>
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`} target="_blank" rel="noopener noreferrer" className="share-option">
              <FaFacebookF /> Facebook 
            </a>
            <a href={`https://twitter.com/intent/tweet?text=${encodedMessage}`} target="_blank" rel="noopener noreferrer" className="share-option">
              <FaTwitter /> X
            </a>
            
            <button onClick={copyToClipboard} className="share-option">
              <FaLink /> Copy Link
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareModal;
